import '../../scripts/common';

import '../../scripts/autosize';
import 'animate.css/animate.css';
import '../../scripts/animate';
import '../../scripts/picture';
import '../../scripts/mask';

import Vue from 'vue';
import VueMask from 'vue-the-mask';
import { mapGetters } from 'vuex';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import PageScrollBtn from '../../components/simple/PageScrollBtn';
import Field from '../../components/base/Field';
import Radio from '../../components/base/Radio';
import Rating from '../../components/base/Rating';
import ProductQuickView from '../../components/ProductQuickView';
import initRadioTabs from './initRadioTabs';
import initPopupQuickView from './quickView';
import initRegPictures from './regPictures';
import getMapInstance from '../../components/YMaps/map-selected-shop';

import basket from './vue/basket.vue';
import basketFinish from './vue/basket-finish.vue';
import basketOrder from './vue/basket-order.vue';
import vuexStore from './vuexStore';

import './styles.css';
import '../../styles/product-outlet.css';

import '../../images/sprite/close_sm.svg';
import '../../images/sprite/gift_2.svg';
import '../../images/sprite/circle_minus.svg';
import '../../images/sprite/circle_equals.svg';
import '../../images/sprite/circle_plus.svg';
import '../../images/sprite/plant.svg';
import '../../images/responsive/noPhotoBig.jpg';
import '../../images/responsive/noPhotoSmall.jpg';

$(() => {
    initVue();

    Header.create();
    Footer.create();
    PageScrollBtn.create();
    ProductQuickView.create();
    Field.create();
    Radio.create();
    Rating.create();
    initRadioTabs();
    initPopupQuickView(vuexStore);
    initRegPictures();
    initCartMap();
    initCartForm();
    Vue.use(VueMask);
});

function initVue() {
    Vue.filter('price', function(value) {
        const val = (value / 1).toFixed(2);
        return `${val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '&nbsp')} ₽`;
    });

    const vm = new Vue({
        components: { basket, basketFinish, basketOrder },
        store: vuexStore,
        computed: {
            ...mapGetters(['getCurrentTab']),
        },
    });
    vm.$mount('#basket-vue-app');
}

function initCartMap() {
    const $cartMap = $('.js-cart-points-map');
    if (!$('.js-cart-points-map').length) return;

    const initMap = getMapInstance();

    $(document).on('change', '[name="radio-delivery-type"]', ({ currentTarget }) => {
        const $deliveryRadio = $(currentTarget);
        const deliveryType = $deliveryRadio.attr('data-delivery');

        if (deliveryType === 'self-delivery') {
            $cartMap.addClass('is-open');

            if (!$cartMap.find('.ylist').hasClass('is-loaded')) {
                initMap();
            }
        } else {
            $cartMap.removeClass('is-open');
        }
    });
}

function initCartForm() {
    const $cartMap = $('.js-cart-form');
    const items = [];

    if (!$('.js-cart-form').length) return;

    function showItem($deliveryRadio) {
        const deliveryType = $deliveryRadio.attr('data-delivery');

        if (deliveryType === 'delivery') {
            $cartMap.addClass('is-open');
            if (items.length) {
                $('.js-cart-form input').each((i, item) => {
                    item.required = items[i];
                });
            }
        } else {
            $cartMap.removeClass('is-open');
            $('.js-cart-form input').each((i, item) => {
                items[i] = item.required;
                item.required = false;
            });
        }
    }

    $(window).on('load', () => {
        const $deliveryRadio = $('[name="radio-delivery-type"]:checked');
        showItem($deliveryRadio);
    });

    $(document).on('change', '[name="radio-delivery-type"]', ({ currentTarget }) => {
        const $deliveryRadio = $(currentTarget);
        showItem($deliveryRadio);
    });
}
